<div class="border-grey-light header-container">
  <div class="row gap-22 mobile-row">
    <div class="col-md col-2 col-xs-4 border-blue"></div>

    <div class="col-md col-2 col-xs-4 border-blue"></div>

    <div class="col-md col-2 col-xs-4 border-grey"></div>
  </div>

  <div class="row d-flex justify-content-end mg-top-8">
    <p>Passo 2 de 3</p>
  </div>
  <h5 class="mg-top-16 mg-bottom-16">Finalização do cadastro</h5>
  <p class="p-text-grey mg-bottom-32">
    Complete as informações necessárias para começar a operar na plataforma.
  </p>
</div>

<div class="padding-16 border-buttons">
  <div class="row mg-bottom-16">
    <h6 class="font-mobile">Informações complementares</h6>
  </div>

  <form [formGroup]="individualComplementaryForm">
    <div class="row mt-4">
      <div class="row-question">
        <h4>FATCA - Foreign Account Tax Compliance Act</h4>

        <img (click)="openFatcaModal()" src="assets/image/question-icon.svg" />
      </div>

      <span class="p-text-grey">
        Pessoa que é residente fiscal nos EUA (permaneceu por mais de 183 dias,
        nasceu nos EUA ou territórios norte-americanos, possui nacionalidade,
        dupla nacionalidade ou cidadania americana, possui visto de residência
        e/ou greencard ou entrega declaração de imposto dos EUA).
      </span>
    </div>

    <div class="row-question p-text-grey">
      <mat-label>Possui residência fiscal nos EUA?</mat-label>
    </div>

    <div class="row d-flex radio-input align-items-center">
      <div class="radios radio-input-reside">
        <mat-radio-group
          class="w-100"
          formControlName="isFATCA"
          (change)="
            requiredSSN(
              individualComplementaryForm,
              individualComplementaryForm.value.isFATCA
            )
          "
        >
          <mat-radio-button [value]="false">Não</mat-radio-button>
          <mat-radio-button [value]="true">Sim</mat-radio-button>
        </mat-radio-group>
      </div>

      <div class="col-md">
        <ng-container *ngIf="individualComplementaryForm.value.isFATCA">
          <mat-form-field appearance="outline">
            <mat-label> Número de cadastro S.S.N / TIN:</mat-label>
            <input
              matInput
              formControlName="identificationNumber"
              type="text"
              class=""
              maxlength="20"
              name="identificationNumber"
              required
            />
            <mat-error
              *ngIf="
                individualComplementaryForm.controls.identificationNumber
                  .touched &&
                individualComplementaryForm.controls.identificationNumber.errors
                  ?.required
              "
            >
              Número de cadastro S.S.N / TIN obrigatório
            </mat-error>
          </mat-form-field>
        </ng-container>
      </div>
    </div>

    <div class="row mt-4">
      <div class="row-question">
        <h4>Declaração de PEP - Pessoa politicamente exposta</h4>
        <img (click)="openPepModal()" src="assets/image/question-icon.svg" />
      </div>

      
    </div>
    <span class="p-text-grey">
      Indique se você, ou alguém próximo, ocupa ou ocupou posições de destaque
      no setor público nos últimos cinco anos.
    </span>

    <div class="row-question p-text-grey">
      <mat-label>É PEP e/ou tem relacionamento com PEP?</mat-label>
    </div>

    <div class="radios mt-4">
      <mat-radio-group class="w-100" formControlName="isPEP">
        <mat-radio-button [value]="false">Não</mat-radio-button>
        <mat-radio-button [value]="true">Sim</mat-radio-button>
      </mat-radio-group>
    </div>
  </form>
</div>

<div
  class="row buttons-confirm d-flex justify-content-between padding-bottom-32 padding-left-20 mg-top-24"
>

  <button
    id="btn-primary-return"
    class="btn btn-block btn-outline-primary"
    type="button"
    (click)="goBack()"
  >
    Voltar
  </button>

  <button
    
    class="btn btn-dark-primary-blue-pf"
    type="button"
    (click)="update()"
          [disabled]="individualComplementaryForm?.invalid || loading"
  >
   Avançar
    <span class="spinner-border spinner-border-sm" *ngIf="loading"></span>
  </button>
</div>
